import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Button } from '../../../../Button';
import { useState } from 'react';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

export type ShowMoreContentProps = {
  canShowMore?: boolean;
  children: (showingMore: boolean) => React.ReactNode;
  buttonText: string | ((showingMore: boolean) => string);
};

const useStyles = makeStyles()((theme) => ({
  showMoreButton: {
    fontSize: '14px',
    textTransform: 'unset',
    color: theme.palette.text.secondary,
    paddingLeft: theme.spacing(1)
  }
}));

export const ShowMoreContent: React.FC<ShowMoreContentProps> = ({ children, canShowMore = true, buttonText }) => {
  const { classes } = useStyles();
  const [ showingMore, setShowingMore ] = useState(false);

  return (
    <Box display="flex" flexDirection="column" gap="6px" width="100%">
      <div>
        {children(showingMore)}
      </div>
      {canShowMore && (
        <Box ml={-1}>
          <Button
            size="small"
            endIcon={showingMore ? <ExpandLess /> : <ExpandMore />}
            className={classes.showMoreButton}
            onClick={() => setShowingMore(p => !p)}
          >
            {typeof buttonText === 'string' ? buttonText : buttonText(showingMore)}
          </Button>
        </Box>
      )}
    </Box>
  );
};
